module.exports = __webpack_public_path__ + "img/staff.6b4f4245.png";